import { useEffect, useState } from 'react';
import {
  getRepresentantManaged,
  RepresentantCompanyManaged,
} from 'services/actions/representant_dashboard';
import { RepresentedTypes } from 'store/modules/profile_store/types';
import { CompanyCount, companyCounts } from './useRepresentantDashboard';

export type ManagedMetric = 'tarefas_hoje' | 'tarefas_atrasadas' | 'andamentos';

const METRICS: ManagedMetric[] = ['tarefas_hoje', 'tarefas_atrasadas', 'andamentos'];

export function useRepresentantManaged(companies: RepresentedTypes[], scope: string) {
  const enabled = companies.length > 1;
  const companiesKey = companies.map(({ id }) => id).join(',');
  const [data, setData] = useState<RepresentantCompanyManaged[]>();
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    setData(undefined);
    setError(false);
    getRepresentantManaged(companiesKey.split(',').map(Number), scope)
      .then((response) => active && setData(response.data.empresas))
      .catch(() => active && setError(true));

    return () => {
      active = false;
    };
  }, [enabled, companiesKey, scope]);

  const breakdown = (metric: ManagedMetric): CompanyCount[] =>
    data
      ? companyCounts(companies, (id) => data.find((company) => company.id === id)?.[metric])
      : [];

  return {
    enabled,
    error,
    breakdown: Object.fromEntries(METRICS.map((metric) => [metric, breakdown(metric)])) as Record<
      ManagedMetric,
      CompanyCount[]
    >,
  };
}
